export default __webpack_public_path__ + "static/media/templateMark_ic.0e5c135b.svg";